import { Box } from "@mui/material";
import React from "react";

interface FrenchFlagProps {
  width?: number;
  height?: number;
  top?: number;
  right?: number;
}

const FrenchFlag: React.FC<FrenchFlagProps> = ({
  width = 50,
  height = 40,
  top = 4,
  right = 4,
}) => (
  <Box
    sx={{
      position: "absolute",
      top,
      right,
      display: "flex",
      flexDirection: "row",
      width,
      height,
      border: "1px solid #ccc",
      overflow: "hidden",
    }}
  >
    <Box sx={{ flex: 1, bgcolor: "#002395" }} />
    <Box sx={{ flex: 1, bgcolor: "#FFFFFF" }} />
    <Box sx={{ flex: 1, bgcolor: "#ED2939" }} />
  </Box>
);

export default FrenchFlag;
